<ng-container *ngIf="memberCard$ | async as memberCard">
  <ng-container *notInPopulation="[populations.Kids]">
    <div class="member-card text-white bg-primary" *ngIf="memberDetails$ | async as memberDetails">
      <div class="col-10 details-container">
        <!--Name and ID-->
        <h5 class="mb-1 card-name w-100">{{ memberDetails.FirstName }} {{ memberDetails.Surname }}</h5>
        <ng-container *inPopulation="[populations.Guardian]">
          <span class="member-name font-size-14">
            {{ 'member.product.code.guardian' | translate : { fgbdefault: 'Guardian' } }}
          </span>
        </ng-container>
        <div class="account-details">
          <div class="account-id">
            <label class="mb-0 font-size-14">{{ 'member.card.accountid' | translate }}</label>
            <div class="font-size-14">{{ memberDetails.ExternalRefNumber }}</div>
          </div>
          <div class="divider"></div>
          <div class="member-id">
            <label class="mb-0 font-size-14">{{ 'member.card.memberid' | translate }}</label>
            <div class="font-size-14">{{ memberDetails.MemberId }}</div>
          </div>
        </div>
      </div>
      <div class="logo-container d-none d-lg-block">
        <!--Logo-->
        <img class="card-logo" src="assets/images/logo.svg" alt="member-card-logo" draggable="false" />
      </div>
    </div>
  </ng-container>
</ng-container>

<ng-container *inPopulation="[populations.Kids]">
  <div
    class="member-card text-white bg-primary cursor-pointer"
    *ngIf="{ details: memberDetails$ | async, card: memberCard$ | async } as member"
  >
    <div class="col-10 details-container">
      <h5 class="mb-1 card-name w-80">{{ member.details.FirstName }} {{ member.details.Surname }}</h5>
      <span class="member-name font-size-14">
        <ng-container *inProductCode="[productcode.PaidKid]">
          {{ 'member.card.paid' | translate : { fgbdefault: 'All-Star' } }}
        </ng-container>
        <ng-container *inProductCode="[productcode.FreeKid]">
          {{ 'member.card.free' | translate : { fgbdefault: 'Club Member' } }}
        </ng-container>
      </span>
      <div class="dob">
        <label class="mb-0 font-size-12">{{ 'member.card.dob' | translate }}</label>
        <div class="font-size-14">{{ member.details.DOB | date : 'MMM dd, yyyy' }}</div>
      </div>
    </div>

    <div class="card-button-logo logo-container" *ngIf="member.card">
      <img *inProductCode="[productcode.FreeKid]" class="logo d-flex" src="assets/images/jr_jays_logo.png" draggable="false" />
      <img
        *inProductCode="[productcode.PaidKid]"
        class="logo"
        alt="kidslogo"
        src="assets/images/kids/JJAllStar.png"
        draggable="false"
      />
      <button (click)="openChildBarcode(barcodeModal)" class="btn btn-show-card bg-white text-primary">Show Card</button>
    </div>
  </div>
</ng-container>

<!-- Barcode modal -->
<ng-template #barcodeModal let-modal>
  <div
    class="barcode rounded"
    *ngIf="{ code: barcode$ | async, member: memberDetails$ | async, card: memberCard$ | async } as details"
  >
    <div class="barcode-body d-flex align-items-center flex-column" *ngIf="details.card">
      <button class="membercard-barcode-modal-close-btn" (click)="modal.close()">
        <i class="material-icons">close</i>
      </button>
      <h5 class="barcode-title text-black">{{ details.member.FirstName }} {{ details.member.Surname }}</h5>
      <span class="barcode-subtitle font-size-10 text-black">
        <ng-container *inProductCode="[productcode.PaidKid]">
          {{ 'member.card.paid' | translate : { fgbdefault: 'All-Star' } }}
        </ng-container>
        <ng-container *inProductCode="[productcode.FreeKid]">
          {{ 'member.card.free' | translate : { fgbdefault: 'Club Member' } }}
        </ng-container>
      </span>
      <ng-container *ngIf="details.code.Barcode; else loadingRef">
        <qrcode [qrdata]="details.code.Barcode" [width]="150" [errorCorrectionLevel]="'M'" [elementType]="true"></qrcode>
      </ng-container>
    </div>
    <div class="barcode-footer text-white bg-primary" *ngIf="details.member">
      <div class="dob">
        <label class="mb-1">{{ 'member.card.dob' | translate }}</label>
        <div class="font-size-14">{{ details.member.DOB | date : 'MMM dd, yyyy' }}</div>
      </div>

      <div class="logo-container">
        <ng-container *inProductCode="[productcode.FreeKid]">
          <img class="d-flex member-card-logo" alt="junior jays logo" src="assets/images/jr_jays_logo.png" draggable="false" />
        </ng-container>
        <ng-container *inProductCode="[productcode.PaidKid]">
          <img src="assets/images/kids/JJAllStar.png" alt="junior all star logo" draggable="false" />
        </ng-container>
      </div>
    </div>
  </div>
</ng-template>
